import { WebCoreFactory } from '@lemoncloud/lemon-web-core';

import { EnhancedStorage } from '@codes/utils';

export const ENV = import.meta.env.VITE_ENV.toLowerCase();
export const PROJECT = import.meta.env.VITE_PROJECT.toLowerCase();
export const REGION = import.meta.env.VITE_REGION?.toLowerCase() || 'ap-northeast-2';
export const OAUTH_ENDPOINT = import.meta.env.VITE_OAUTH_ENDPOINT.toLowerCase();
export const BACKEND_ENDPOINT = import.meta.env.VITE_BACKEND_ENDPOINT.toLowerCase();
export const LANGUAGE_KEY = 'i18nextLng';

export const enhancedStorage = new EnhancedStorage();

export const webCore = WebCoreFactory.create({
    cloud: 'aws',
    project: `${PROJECT}_${ENV}`,
    oAuthEndpoint: OAUTH_ENDPOINT,
    region: REGION,
    storage: enhancedStorage as Storage,
});
